import { createSelector } from 'reselect';
import { RootState } from 'src/redux/store';

const selectPurchaseOrder = (state: RootState) => state.purchaseOrder;

// Also for selected purchase orders
const selectPurchaseOrders = createSelector(
  selectPurchaseOrder,
  (state) => state.purchaseOrders
);

const selectPurchaseOrderLoading = createSelector(
  selectPurchaseOrder,
  (state) => state.isPurchaseOrdersLoading
);

const selectPurchaseOrderMeta = createSelector(
  selectPurchaseOrder,
  (state) => state.meta
);

const selectPurchaseOrderParams = createSelector(
  selectPurchaseOrder,
  (state) => state.params
);

const selectSelectedPurchaseOrders = createSelector(
  selectPurchaseOrder,
  (state) => state.selectedPurchaseOrders
);

const selectPOReports = createSelector(
  selectPurchaseOrder,
  (state) => state.poReports
);

const selectReportsLoading = createSelector(
  selectPurchaseOrder,
  (state) => state.isReportsLoading
);

const selectReportsMeta = createSelector(
  selectPurchaseOrder,
  (state) => state.reportsMeta
);

const selectReportsParams = createSelector(
  selectPurchaseOrder,
  (state) => state.reportsParams
);

const selectTotalAmount = createSelector(
  selectPurchaseOrder,
  (state) => state.totalAmount
);

const selectParams = createSelector(
  selectPurchaseOrder,
  (state) => state.params
);

const selectIsShowList = createSelector(
  selectPurchaseOrder,
  (state) => state.isShowList
);

export const selectors = {
  selectPurchaseOrders,
  selectPurchaseOrderLoading,
  selectPurchaseOrderMeta,
  selectPurchaseOrderParams,
  selectParams,
  selectSelectedPurchaseOrders,
  selectTotalAmount,
  selectIsShowList,

  // POReports
  selectPOReports,
  selectReportsLoading,
  selectReportsMeta,
  selectReportsParams
};
